import React, { useState } from 'react'
import styled from 'styled-components';
import { ConfirmIcon } from '../../components/Icons/ConfirmIcon';
import { Modal } from '../../components/Modal/Modal';
import { Contract } from 'ethers/lib/ethers';
import { ErrorIcon } from '../../components/Icons/ErrorIcon';
import { BootyABI } from '../../constants/ABI/BootyABI';
import { BOOTY_ADDRESS } from '../../constants/addresses';
import { Spinner } from '../../components/Loaders';
import { artifacts, crates } from './Items';
import { CONNECTED_CHAIN_EXPLORER } from '../../constants/chains';
import { Media } from '../../styles';
import { useEthersProvider, useEthersSigner } from '@/utils/wagmi-ethers-adapters/ethers';

interface ConfirmCraftProps {
    visible: boolean,
    setVisible: (visible : boolean) => void,
    setCraftDisabled: (disabled : boolean) => void,
    burnAmounts: Record<string, number>,
    recipe: any,
    recipeID: number
    craftAmount: number,
    update: () => void
}

export const ConfirmCraft = ({visible, setVisible, setCraftDisabled, burnAmounts, recipe, recipeID, craftAmount, update}: ConfirmCraftProps) => {
    const { data: signer } = useEthersSigner();
    const provider = useEthersProvider();
    
    const [confirmDisabled, setConfirmDisabled] = useState(false)
    const [txState, setTxState] = useState('')
    const [txHash, setTxHash] = useState('')

    const booty = new Contract(BOOTY_ADDRESS, BootyABI, signer || provider)

    const ingredients : any[] = artifacts.filter((artifact) => burnAmounts[artifact.image] != null)
    const result = visible ? recipe.outputs[0] : null
      
    const executeTransaction = () => {
        if(signer){
            setConfirmDisabled(true)
            setTxState('Pending')

            booty.craftArtifact([recipeID], [craftAmount]).then((response: any) => {
            
                setTxState('Submitted')

                response.wait().then((result : any) => {
                    setTxHash(result.transactionHash)
                    if(result.status == 1){ //Success
                        setTxState('Success')
                    } else {
                        setTxState('Error')
                    }
                    setConfirmDisabled(false);
                })
            }).catch(() => {
                setTxState('')
                setConfirmDisabled(false);
            });
        }
    }

    return (
        <StyledModal
            title={'Confirm Craft'}
            isVisible={visible}
            onClose={() => { 
                setCraftDisabled(false)
                if(txState == 'Success'){
                    update()
                }
                setTxState('')
                setVisible(false)
            }}
        >
            <Column style={{margin: '8px 0px', height: 'fit-content'}}>
                <Label style={{marginBottom: '8px', color: '#7D7D97'}}>Ingredients</Label>
                <ArtifactView>
                    {ingredients.map((ingredient, index) => {
                        return (
                            <>
                                <Column key={ingredient.name}>
                                    <Amount>
                                        <IngredientText>{ingredient.name}</IngredientText>
                                        <Item>
                                            <img src={`../../assets/booty/${ingredient.image}.jpg`}/>
                                            <ItemBalance>{burnAmounts[ingredient.image]}</ItemBalance>
                                        </Item>
                                    </Amount>
                                </Column>
                                {index < ingredients.length - 1 &&
                                    <Label key={index} style={{fontSize: '54px', margin: 'auto', color: "#00BDFF"}}>+</Label>
                                }
                            </>     
                        )                    
                    })}
                </ArtifactView>
                <Label style={{marginBottom: '8px', color: '#7D7D97'}}>Result</Label>
                {result && 
                    <ArtifactView>
                        <Column key={result.name}>
                            <div style={{display: 'flex', justifyContent: 'center', columnGap: '8px'}}>
                                <Result>
                                    <img src={`../../assets/booty/${result.image}.jpg`}/>
                                    <ResultBalance>{craftAmount}</ResultBalance>
                                </Result>
                                <ResultInfo>
                                    <ArtifactName>{result.name}</ArtifactName>
                                    <ArtifactDesc>{result.desc}</ArtifactDesc>
                                    {'effect' in result && result['effect']?.type == 'Booster' && 
                                    <Row style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '8px'}}>
                                        <Value style={{lineHeight: '12px', fontSize: '12px'}}>{`${result.effect?.value == 0 ? '???' : result.effect?.value + '%'}`}</Value>        
                                        <img style={{width: '24px', margin: '0 4px'}} src={`../../assets/icons/boost.svg`}/>
                                        <Value style={{lineHeight: '12px', fontSize: '12px'}}>{`${result.effect?.duration}d`}</Value>
                                    </Row>
                                    }
                                </ResultInfo>
                            </div>
                        </Column>
                    </ArtifactView>
                }
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    {
                        txState && txState != 'Pending' && 
                        <>
                            {txState != 'Submitted' && <Label style={{margin: '8px auto 0 auto', color: '#7D7D97'}}>{txState == 'Success' ? 'Success!' : 'Error'}</Label>}
                            <CircleContainer>
                                {txState == 'Success' ? <ConfirmIcon/> : txState == 'Error' ? <ErrorIcon/> : <Spinner/>}
                            </CircleContainer>
                            {txState != 'Submitted' && <ExplorerLink href={CONNECTED_CHAIN_EXPLORER + 'tx/' + txHash} target="_blank">{`View in Explorer \u2192`}</ExplorerLink>}
                        </>
                    }
                    {
                    (txState == '' || txState == 'Pending') &&
                        <>
                            <Text>NOTE: This is an irreversible action and all ingredients will be burned permanently</Text>
                            <ActionButton onClick={executeTransaction} disabled={confirmDisabled}>
                                <ConfirmIcon/>
                                Confirm Craft
                            </ActionButton>
                        </>
                    }
                    {
                        txState == 'Submitted' &&
                        <Label style={{margin: '8px auto 2px auto', color: '#7D7D97'}}>Waiting for blockchain confirmation...</Label>
                    }
                </div>
            </Column>
        </StyledModal>
    )
}

const StyledModal = styled(Modal)`
  height: fit-content;
//   width: 424px;

  ${Media.mobile} {
    height: 85%;
    max-width: 100%;
    margin-top: 15.5%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const ArtifactView = styled.div`
  display: flex;
  position: relative;
  border-radius: 16px;
  z-index: 1;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 8px;
  overflow: auto;
`

const Amount = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  row-gap: 4px;
`

const Item = styled.div`
  width: 96px;
  height: 96px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  background: #151530;
  border: 2px solid #1E2239;
  border-radius: 16px;

  img {
    width: 100%;
    border-radius: 14px;
  }
`

const ItemBalance = styled.p`

  position: absolute;
  min-width: 28px;
  min-height: 28px;
  font-weight: 10;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  margin-top: 60px;
  margin-left: 60px;

  border-radius: 11px;
  background: #00BDFF;
  color: #1E2239;
`

const Result = styled(Item)`
  width: 128px;
  height: 128px;
`;

const ResultBalance = styled(ItemBalance)`
    min-width: 36px;
    min-height: 36px;
    line-height: 36px;
    text-align: center;
    margin-top: 82px;
    margin-left: 82px;
`

const ResultInfo = styled.div`
  width: 128px;
  height: 128px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 10;
  font-size: 20px;
  letter-spacing: -0.03em;
  color: #FFFFFF;

  margin: 4px;
`;

const Label = styled.p`
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  letter-spacing: -0.02em;
`;

const IngredientText = styled(Label)`
  font-size: 14px;
  font-weight: 100;
`

const CircleContainer = styled.div`
  width: 74px;
  height: 74px;
  margin: 16px auto;
  color: #00BDFF;
`

const Value = styled(Label)`
  font-weight: 100;
  line-height: 24px;
  color: #00BDFF;
`
const ArtifactName = styled.p`
  font-weight: 500;
  font-size: 16px;
  color: #00BDFF;
  margin-bottom: 8px;
  text-align: center;
`

const ArtifactDesc = styled.p`
  font-weight: 250;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  padding: 0 6px;
`;

const Text = styled.p`
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  color: #7d7d97;
  text-align: center;
`;

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 264px;
  height: 76px;
  margin-top: 12px;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #0a0e27;
  background: linear-gradient(90.44deg, #37dcf2 0.87%, #07c0fb 100%);
  border-radius: 16px;

  svg {
    height: 28px;
    width: 28px;
    margin-right: 8px;
    color: #464659;
  }

  &:not(:disabled) svg path {
    fill: #151530;
  }

  &:disabled {
    background: #0a0e27;
    color: #464659;
    border: solid 2px #464659;
  }
`;

const ExplorerLink = styled.a`
    font-weight: 100;
    font-size: 14px;
    line-height: 14px;
    text-align: center;
    color: #7D7D97;
    white-space: nowrap;
    letter-spacing: -0.02em;

    :hover {
        color: #00BDFF;
    }
`;